import React, { useState } from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import bigInt from "big-integer";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box, Grid } from "@material-ui/core";
import styles from "../../../styles/global-styles";
import { Link } from "react-router-dom";
import NewProduct from "./NewProduct";
import AddMovileToInventory from "./additions/AddMovileToInventory";
import AddAccesoryToInventory from "./additions/AddAccesoryToInventory";
import AddChipToInventory from "./additions/AddChipToInventory";
import ResumeMovileDistribution from "./resumesDistribution/ResumeMovileDistribution";
import ResumeAccesoryDistribution from "./resumesDistribution/ResumeAccesoryDistribution";
import { validateEmptyValuesInForm } from "../../../_utils/utils";
import ResumeChipDistribution from "./resumesDistribution/ResumeChipDistribution";
import AddCashCardToInventory from "./additions/AddCashCardToInventory";
import ResumeCashCardDistribution from "./resumesDistribution/ResumeCashCardDistribution";

const usetSyles = makeStyles(() => ({
  numberCircle: styles.numberCircle,
  backgroundIcon: styles.backgroundIcon,
  link: styles.link,
  stepper: {
    "&:hover": {
      border: "1px solid #1C2668",
      // padding: "10px 10px",
      fontWeight: "bold",
      cursor: "pointer",
    },
  },
}));

const StepperInventory = ({ location: { state } }) => {
  const classes = usetSyles();

  const [stepSelected, setStepSelected] = useState(1);
  const [productType, setProductType] = useState("");
  const [bulkArray, setBulkArray] = useState([]);
  const [detailProductCreated, setDetailProductCreated] = useState({});

  const handleStepSelected = (number) => setStepSelected(number);

  const handleProductCreated = (newProduct, type, aux) => {
    const validatedProduct = validateEmptyValuesInForm(newProduct);
    console.log("validatedProduct", validatedProduct);
    if (type === "chip") {
      const sizeIccid =
        bigInt(newProduct.iccidEnd).value -
        bigInt(newProduct.iccidInit).value +
        bigInt(1).value;
      setDetailProductCreated({
        ...detailProductCreated,
        ...validatedProduct,
        sizeIccid,
      });
    } else {
      setDetailProductCreated({
        ...detailProductCreated,
        ...validatedProduct,
      });
    }
    setProductType(type);
    setStepSelected(2);
  };

  const handleBulkCreated = (isCreated, _, __, bulkData) => {
    if (isCreated) setStepSelected(3);
    if (bulkData) setBulkArray(bulkData);
  };

  const handleChipBulkCreated = (bulkcreated) => {
    setBulkArray(bulkcreated);
    const validatedProduct = validateEmptyValuesInForm(bulkcreated[0]);
    console.log("validatedChipProduct", validatedProduct);
    setDetailProductCreated({
      ...detailProductCreated,
      ...validatedProduct,
    });
    setStepSelected(3);
  };

  return (
    <React.Fragment>
      <div style={{ display: "inline-flex" }}>
        <ArrowBackIosIcon color="primary" />
        <Typography variant="body1" component={"div"}>
          <Box>
            {" "}
            <Link to="/dashboard/inventario/moviles" className={classes.link}>
              Cancelar
            </Link>
          </Box>
        </Typography>
      </div>

      <Grid
        style={{ marginTop: 15 }}
        container
        direction="row"
        justify="space-evenly"
        alignItems="center"
      >
        <Grid item>
          <div
            style={{ display: "inline-flex" }}
            className={classes.stepper}
            onClick={() => handleStepSelected(1)}
          >
            <div className={classes.numberCircle}>1</div>
            <Typography variant="h5">
              <Box ml={3} mt={1}>
                Captura
              </Box>
            </Typography>
          </div>
        </Grid>
        <Grid item>
          <div style={{ display: "inline-flex" }} className={classes.stepper}>
            <div className={classes.numberCircle}>2</div>
            <Typography variant="h5">
              <Box ml={3} mt={1}>
                Inventario
              </Box>
            </Typography>
          </div>
        </Grid>
        <Grid item>
          <div style={{ display: "inline-flex" }} className={classes.stepper}>
            <div className={classes.numberCircle}>3</div>
            <Typography variant="h5">
              <Box ml={3} mt={1}>
                Distribución
              </Box>
            </Typography>
          </div>
        </Grid>
      </Grid>

      <Grid
        style={{ marginTop: 20 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        {/** STEPPER 1 */}
        {stepSelected === 1 && (
          <NewProduct
            newProductCreated={handleProductCreated}
            productPreSelected={state?.tabOption || null}
          />
        )}

        {/** STEPPER 2 */}
        {stepSelected === 2 && productType === "movile" && (
          <AddMovileToInventory
            detailProduct={detailProductCreated}
            productsCreated={handleBulkCreated}
          />
        )}
        {stepSelected === 2 && productType === "accesory" && (
          <AddAccesoryToInventory
            detailProduct={detailProductCreated}
            accesoriesCreated={handleBulkCreated}
            firstBulk
            isNewStock={false}
          />
        )}
        {stepSelected === 2 && productType === "chip" && (
          <AddChipToInventory
            detailProduct={detailProductCreated}
            bulkChipCreated={handleChipBulkCreated}
          />
        )}
        {stepSelected === 2 && productType === "cashCard" && (
          <AddCashCardToInventory
            detailProduct={detailProductCreated}
            bulkCashCardCreated={handleBulkCreated}
          />
        )}

        {/** STEPPER 3 */}
        {stepSelected === 3 && productType === "movile" && (
          <ResumeMovileDistribution detailProduct={detailProductCreated} />
        )}
        {stepSelected === 3 && productType === "accesory" && (
          <ResumeAccesoryDistribution detailProduct={detailProductCreated} />
        )}
        {stepSelected === 3 && productType === "chip" && (
          <ResumeChipDistribution
            bulkChip={bulkArray}
            detailProduct={detailProductCreated}
          />
        )}
        {stepSelected === 3 && productType === "cashCard" && (
          <ResumeCashCardDistribution
            detailProduct={detailProductCreated}
            bulkCashCard={bulkArray}
          />
        )}
      </Grid>
    </React.Fragment>
  );
};

export default StepperInventory;
